import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";

const NotFound = () => {
  const { t } = useLanguage();
  return (
    <section className="min-h-[60vh] flex items-center justify-center bg-white" data-testid="not-found-page">
      <div className="max-w-xl mx-auto px-6 text-center py-24">
        <div className="text-xs uppercase tracking-[0.22em] text-teal-700 mb-3">404</div>
        <h1 className="font-display text-4xl lg:text-5xl text-slate-900 tracking-tight">
          {t("notFound.title")}
        </h1>
        <p className="mt-4 text-slate-600">
          {t("notFound.lead")}
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 px-6 h-12 rounded-full bg-teal-700 text-white text-sm font-medium hover:bg-teal-800"
          data-testid="back-home-link"
        >
          {t("notFound.backHome")}
        </Link>
      </div>
    </section>
  );
};

export default NotFound;
